// extracted by mini-css-extract-plugin
export default {"tab":"AjMNG","tabActive":"KuzmY","icon":"S8RsI","text":"prMy_"};